import React, { useState } from "react";
import { Route, Redirect, Link } from "react-router-dom";
import { isLogin, logout } from "../utils/AuthGuard";
import logo from "../assets/images/logo-payap.png";

import { Radio, Row, Col, Affix, Button, Drawer } from "antd";


const PrivateRoute = ({ component: Component, ...rest }) => {
    
  const [language, setLanguage] =  useState( localStorage.getItem("Language") );
  
  const [visible, setVisible] = useState(false);
  
  function handleLogout() {
    localStorage.clear();
    localStorage.setItem("Language", "TH");
    logout();
  }

  return (
    // Show the component only when the user is logged in
    // Otherwise, redirect the user to /signin page

    <Route
      {...rest}
      render={(props) =>
        isLogin() ? (
          <div>
            <Affix offsetTop={0}>
              <div style={{ backgroundColor: "#018FD6", padding: 10 }}>
                <Row>
                  <Col style={{ padding: "10px 0", marginLeft: 15 }}>
                  <Link to="/home"> 
                    <img src={logo} alt="Logo" />
                  </Link>
                  </Col>

                  <div className="title">
             
                    <p>
                      สำนักทรัพยากรบุคคล <br /> Office of Human Resources
                    </p>

                  </div>
            


                  <Col xs={10} sm={18} md={12} lg={14} xl={16}>
                    <div className="menuCon">

                      {/* render desktop menu */}
                      <div className="rightMenu">
                        <Row>
                          <Col>
                            <p
                              style={{
                                color: "#fff",
                                fontSize: 16,
                                padding: "10px 0",
                              }}
                            >
                              เลือกภาษา
                            </p>
                          </Col>

                          <Col>
                            <div style={{ padding: "10px 0", marginLeft: 15 }}>
                              <Radio.Group
                                defaultValue={localStorage.getItem("Language")}
                                buttonStyle="solid"
                              >
                                <Radio.Button
                                  value="TH"
                                  onClick={() => [setLanguage("TH"),localStorage.setItem('Language','TH')]}
                                >
                                  ไทย
                                </Radio.Button>
                                <Radio.Button
                                  value="EN"
                                  onClick={() => [setLanguage("EN"),localStorage.setItem('Language','EN')]}
                                >
                                  English
                                </Radio.Button>
                              </Radio.Group>
                            </div>
                          </Col>
                          <Col>
                            <div style={{ padding: "10px 0", marginLeft: 15 }}>
                              <Button onClick={() => handleLogout()}>
                                {language == "TH" ? (
                                  <Link to="/"> ออกจากระบบ </Link>
                                ) : (
                                  <Link to="/"> Sign Out </Link>
                                )}
                              </Button>
                            </div>
                          </Col>
                        </Row>
                      </div>

                      {/* render mobile menu */}
                      <Button
                        className="barsMenu"
                        type="primary"
                        onClick={() => setVisible(true)}
                      >
                        <span className="barsBtn"></span>
                      </Button>
                      <Drawer
                       
                        placement="right"
                        closable={false}
                        onClose={() => setVisible(false)}
                        visible={visible}
                      >
                        <p
                          style={{
                            fontSize: 16,
                          }}
                        >
                          เลือกภาษา
                        </p>
                        <div style={{ padding: "10px 0"}}>
                          <Radio.Group
                            defaultValue={localStorage.getItem("Language")}
                            buttonStyle="solid"
                          >
                            <Radio.Button
                              value="TH"
                              onClick={() => setLanguage("TH")}
                            >
                              ไทย
                            </Radio.Button>
                            <Radio.Button
                              value="EN"
                              onClick={() => setLanguage("EN")}
                            >
                              English
                            </Radio.Button>
                          </Radio.Group>
                        </div>

                        <div style={{ padding: "10px 0" }}>
                          <Button onClick={() => handleLogout()}>
                            {language == "TH" ? (
                              <Link to="/"> ออกจากระบบ </Link>
                            ) : (
                              <Link to="/"> Sign Out </Link>
                            )}
                          </Button>
                        </div>

                      </Drawer>

                    </div>

                  </Col>
                </Row>
              </div>
            </Affix>
            <Component lang={language} {...props} />
          </div>
        ) : (
          <Redirect to="/" />
        )
      }
    />
  );
};

export default PrivateRoute;
